// extracted by mini-css-extract-plugin
export var navigationList = "navigation-module--navigation-list--bg7lh";
export var navigationItem = "navigation-module--navigation-item--MQa3d";